import './WhatsappFloat.css';

const PHONE = '573187260291';
const MESSAGE =
  '¡Hola Santiago! Vi tu portafolio y me interesa un software para mi negocio.';

// Botón flotante de WhatsApp visible en todas las páginas.
export default function WhatsappFloat() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      className="wafloat"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Escríbeme por WhatsApp"
    >
      <span className="wafloat__pulse" aria-hidden="true"></span>
      <i className="bx bxl-whatsapp wafloat__icon" aria-hidden="true"></i>
      <span className="wafloat__label">¿Hablamos?</span>
    </a>
  );
}
